export default __webpack_public_path__ + "static/media/icon-chevron-up.fb613fd1.svg";